import React, { useEffect, useState } from "react";
import CourtOwnerSidebar from "../../components/courtowner/CourtOwnerSidebar";

const CourtOwnerUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const token = localStorage.getItem("courtOwnerToken");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const res = await fetch("https://api.getfitindia.in/api/courtowner/users", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();

        if (Array.isArray(data)) setUsers(data);
        else if (Array.isArray(data?.users)) setUsers(data.users);
        else if (data?.error) setErrorMsg(data.error);
        else setUsers([]);
      } catch (err) {
        console.error("Fetch error:", err);
        setErrorMsg("Failed to fetch users. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [token]);

  const toggleBlock = async (userId) => {
    try {
      const res = await fetch(
        `https://api.getfitindia.in/api/courtowner/users/${userId}/block`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();
      if (data.error) return alert(data.error);

      alert(data.message || "Updated.");
      setUsers((prev) =>
        prev.map((u) =>
          u._id === userId ? { ...u, blocked: data.user?.blocked } : u
        )
      );
    } catch {
      alert("Failed to block/unblock user.");
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F6FB] flex flex-col lg:flex-row">

      {/* Desktop Sidebar */}
      <aside className="hidden lg:block w-64 bg-white shadow h-screen sticky top-0">
        <CourtOwnerSidebar />
      </aside>

      {/* Right content */}
      <main className="flex-1 flex flex-col">

        {/* Top Header Bar */}
        <div className="bg-[#0f2250] text-white w-full">
  <div className="max-w-6xl px-4 py-3 flex items-center">
    
    {/* Mobile Sidebar */}
    <div className="lg:hidden">
      <CourtOwnerSidebar />
    </div>

    {/* Title wrapper for perfect alignment */}
    <div className="text-lg font-semibold  sm:ms-0 md:ms-16 lg:ms-14 mt-1 py-2 ">
      <h1 className="text-lg sm:text-xl font-semibold">
        My Users
      </h1>
    </div>

  </div>
</div>


        {/* Content */}
        <div className="flex-1 px-3 sm:px-5 lg:px-10 py-4 overflow-y-auto">

     <div className="max-w-[100rem] mx-auto">
  {/* Header Row */}
  <div className="mb-4 flex items-center justify-between">
   <span className="text-sm sm:text-base font-semibold text-[#0C295F] ml-[33px]">
  Users linked to your venues
</span>

    <span className="text-xs sm:text-sm text-gray-500">
      Total: {users.length}
    </span>
  </div>

  {/* Table Container */}
 <div className="rounded-xl p-3 sm:p-4 shadow-[0_0_6px_rgba(0,0,0,0.2)] overflow-x-auto">
    {loading && <p className="text-sm text-gray-500">Loading users...</p>}

    {errorMsg && <p className="text-sm text-red-500 mb-3">{errorMsg}</p>}

    {!loading && !errorMsg && users.length === 0 && (
      <p className="text-sm text-gray-600">No users found for your venues.</p>
    )}

    {!loading && !errorMsg && users.length > 0 && (
      <table className="min-w-[700px] w-full text-sm">
        <thead className="bg-[#F3F6FB] text-[#0C295F]">
          <tr>
            <th className="px-3 py-2 border-b text-left">#</th>
            <th className="px-3 py-2 border-b text-left">Name</th>
            <th className="px-3 py-2 border-b text-left whitespace-nowrap">
              Mobile
            </th>
            <th className="px-3 py-2 border-b text-left">Gender</th>
            <th className="px-3 py-2 border-b text-left">City</th>
            <th className="px-3 py-2 border-b text-left whitespace-nowrap">
              Joined Date
            </th>
            <th className="px-3 py-2 border-b text-left">Block</th>
          </tr>
        </thead>

        <tbody>
          {users.map((user, idx) => (
            <tr
              key={user._id || idx}
              className="odd:bg-white even:bg-[#F9FBFF] hover:bg-[#EEF3FF] transition"
            >
              <td className="px-3 py-2 border-b">{idx + 1}</td>
              <td className="px-3 py-2 border-b break-words">{user.name || "N/A"}</td>
              <td className="px-3 py-2 border-b truncate max-w-[120px]">{user.mobile}</td>
              <td className="px-3 py-2 border-b">{user.gender || "N/A"}</td>
              <td className="px-3 py-2 border-b break-words">{user.city || "N/A"}</td>
              <td className="px-3 py-2 border-b whitespace-nowrap">
                {user.createdAt?.split("T")[0] || "N/A"}
              </td>
              <td className="px-3 py-2 border-b">
                <button
                  className={`px-3 py-1 rounded-full text-xs font-semibold transition ${
                    user.blocked
                      ? "bg-red-600 hover:bg-red-700 text-white"
                      : "bg-[#0f2250] hover:bg-[#071833] text-white"
                  }`}
                  onClick={() => toggleBlock(user._id)}
                >
                  {user.blocked ? "Unblock" : "Block"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
</div>

</div>

        </div>
      </main>
    </div>
  );
};

export default CourtOwnerUsers;
